//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useRef } from 'react';

import { useTheme } from '@mui/material/styles';
import {
  Paper,
  Box,
  CardHeader,
} from '@mui/material';

// === COMPONENTS ===
import { Document } from './Document';
import { Block    } from './Block';

//#endregion

const DocMemo   = React.memo( Document );
const BlockMemo = React.memo( Block    );

//-----------------------------------------------------------------
export function Fields(props) {
  //-----------------------------------------------------------------

  //#region [Main] State

  const ref = useRef();

  const theme = useTheme();

  const _styles = {
    field_paper: {
      gridColumn : 'span 4'   ,
      overflow   : 'auto'     ,
      position   : 'relative' ,
      height     : '100%'     ,
      width      : '100%'     ,
      boxShadow  : 0          ,
    },
    document_container: {
      height: '100%', width: '100%',
    },
    container: {
      variant  : 'primary',
      borderRadius: '0.5rem',
      boxShadow: '2',
      width: '100%',
      margin: 0,
      marginBottom: '1rem',
    },
    header: {
      boxShadow: '-0.5em 0  0.01em' + theme.palette.success.main,
      padding: '1rem',
      backgroundColor: theme.palette.success.main,
      color: theme.palette.success.contrastText,
      height: '4rem',
      textAlign: 'center',
      zIndex: 5,
    },
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    const fields_folder    = props.folder   .blocks.map( displayFolderBlock );
    const fields_documents = props.documents.order .map( displayDocument    );

    if( fields_folder.length <= 0 && fields_documents.length <= 0 ) {
      return (
        <Box ref={ref} sx={_styles.field_paper}>
          <Box ref={ref} sx={_styles.container} >
            <CardHeader sx={_styles.header} title='No validation required.' />
          </Box>
        </Box>
      )
    }

    return (
      <Box ref={ref} sx={_styles.field_paper}>
        { fields_folder }
        <Box sx={_styles.document_container}>
          { fields_documents }
        </Box>
      </Box>
    );
  }

  //-----------------------------------------------------------------
  function displayFolderBlock( id ) {
    //-----------------------------------------------------------------
    return <BlockMemo key={ 'f' + id } id={ id } />
  }

  //-----------------------------------------------------------------
  function displayDocument( id ) {
    //-----------------------------------------------------------------
    const document = props.documents.items[id];
    if( !document ) {
      console.log( `Failed to get document with id [${id}].`);
    }
    const timestamp = document?.timestamp;
    return <DocMemo key={ 'd' + id } id={ id } timestamp={timestamp}/>
  }

  //#endregion

  return display();
}